
export function ServiceAreaSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 via-blue-50/30 to-slate-50 relative overflow-hidden">
      {/* Elementos decorativos de fundo */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-32 h-32 bg-blue-600 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-blue-800 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Área de Atendimento
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Atendemos toda São Paulo e região metropolitana com rapidez e qualidade
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Mapa Premium */}
          <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden border border-slate-200">
            {/* Header do Mapa */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-800 p-6 text-white">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                  <i className="ri-map-pin-2-fill text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold">São Paulo & Região</h3>
                  <p className="text-blue-100 text-sm">Cobertura completa em toda a região metropolitana</p>
                </div>
              </div>
            </div>

            {/* Mapa Interativo */}
            <div className="relative h-96">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d467692.0481991799!2d-46.87549604999999!3d-23.6815315!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce448183a461d1%3A0x9ba94b08ff335bae!2sS%C3%A3o%20Paulo%2C%20SP!5e0!3m2!1spt!2sbr!4v1703123456789!5m2!1spt!2sbr"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full"
              ></iframe>
              
              {/* Overlay com informações */}
              <div className="absolute bottom-4 left-4 right-4">
                <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4 shadow-lg border border-white/50">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                      <span className="text-sm font-semibold text-slate-700">Atendimento Ativo</span>
                    </div>
                    <div className="text-xs text-slate-500">24h disponível</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer do Mapa */}
            <div className="bg-slate-50 p-4 border-t border-slate-200">
              <div className="flex items-center justify-between text-sm">
                <div className="flex items-center gap-2 text-slate-600">
                  <i className="ri-time-line"></i>
                  <span>Atendimento 24h</span>
                </div>
                <div className="flex items-center gap-2 text-slate-600">
                  <i className="ri-phone-line"></i>
                  <span>(11) 94894-8561</span>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Premium */}
          <div className="mt-8 relative">
            <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-8 text-white shadow-2xl relative overflow-hidden">
              {/* Elementos decorativos */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-12 -translate-x-12"></div>
              
              <div className="relative z-10 text-center">
                <h3 className="text-2xl font-bold mb-3">
                  Atendemos Toda a Grande São Paulo
                </h3>
                <p className="text-blue-100 mb-6 text-lg">
                  Cobertura completa em todas as regiões da capital e região metropolitana
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <a 
                    href="https://wa.me/5511948948561?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20um%20or%C3%A7amento%20para%20detec%C3%A7%C3%A3o%20de%20vazamento.%20Pode%20me%20ajudar%3F" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-white text-blue-800 hover:bg-blue-50 font-bold rounded-xl text-lg h-14 px-8 shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    Solicitar Atendimento
                  </a>
                  <a 
                    href="tel:11948948561" 
                    className="inline-flex items-center justify-center gap-2 whitespace-nowrap border-2 border-white text-white bg-white/20 backdrop-blur-sm hover:bg-white hover:text-blue-800 font-semibold rounded-xl text-lg h-14 px-8 shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
                  >
                    <i className="ri-phone-line text-xl"></i>
                    Ligar Agora
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
